module.exports = __webpack_public_path__ + "static/icons-sprite-907156b91f10fcef1c29694d58c18c9c.svg";